import View from '../components/PointMirror/View'
import My from '../components/PointMirror/My'
import Manager from '../components/PointMirror/Manager'
import Consult from '../components/PointMirror/Consult'

let routes = {
    path: '/point-mirror',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/point-mirror/view',
            name: 'Espelho de ponto',
            component: View
        },
        {
            path: '/point-mirror-consult',
            name: 'Consulta Espelho de ponto',
            component: Consult
        },
        {
            path: '/point-mirror/my',
            name: 'Meus espelhos de ponto',
            component: My
        },
        {
            path: '/point-mirror/:month?/:year?',
            name: 'Gerenciar espelhos de ponto',
            component: Manager
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/pointMirror.js